const UserSideMenu = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'user.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-home-4-line'
  },
  {
    title: 'My Requests',
    is_heading: false,
    is_active: false,
    link: {
      name: 'user.my-requests'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-currency-line'
  },
  {
    title: 'Pending Approvals',
    is_heading: false,
    is_active: false,
    link: {
      name: 'user.pending-approvals'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-currency-line'
  },
  {
    title: 'Reports',
    name: 'sidebar.reports',
    is_heading: false,
    is_active: false,
    link: '',
    class_name: '',
    is_icon_class: true,
    icon: 'ri-folder-chart-line',
    children: [
      {
        title: 'Request Histories',
        is_active: false,
        link: {
          name: 'user.report-request-histories'
        },
        class_name: '',
        is_icon_class: true,
        icon: 'ri-file-excel-2-line'
      },
      {
        title: 'Approval Histories',
        is_active: false,
        link: {
          name: 'user.report-approval-histories'
        },
        class_name: '',
        is_icon_class: true,
        icon: 'ri-file-excel-2-line'
      }
    ]
  }
]

export default UserSideMenu
